import { SortingTypeIndexPeople } from "../pages/context/support/peopleSorting";


export enum SortingType {
    // latest = 'latest',
    popular = 'popular',
    moderation = 'moderation'
}

export enum SortingTypeIndex {
    price_inc = 10,
    price_dec = 9,
    // latest = 1,
    moderation = 1,
    popular = 2,
    current_competition = 1,
    ended_competition = 2,
    name = 3,
    projects = 4,
    opa = 5,
    updated_team = 6,
    score = 13,
    team_date = 18,
    relevant = 20,
    PersonPopular = 26,
    dezzignPersonPopular = 27,
    hsedesingPersonPopular = 28,
    geograffee_Art_PersonPopular = 29,
    personPopularLastPeriod = 30,
    dezzignPersonPopularLastPeriod = 31,
    editorsChoice = 32,
    course_start = 0,
    designer_name = 0,
    shop = 30,
    team_date_for_manual_tab = 33,
    mediiia_all = 50,
    mediiia_author = 51,
    mediiia_education = 52
}

export const SortingTypeString: Record<SortingTypeIndex, string> = {
    // 1: 'latest',
    0: 'course_start',
    1: 'moderation',
    2: 'popular',
    3: 'name',
    4: 'project',
    5: 'opa',
    6: 'updated_team',
    9: 'price_dec',
    10: 'price_inc',
    13: 'score',
    18: 'team_date',
    20: 'relevant',
    26: 'PersonPopular',
    27: 'dezzignPersonPopular',
    28: 'hsedesingPersonPopular',
    29: 'geograffee_Art_PersonPopular',
    30: 'shop',
    31: 'dezzignPersonPopularLastPeriod',
    32: 'editors_choice',
    33: 'team_date_for_manual_tab',
    50: 'mediiia_all',
    51: 'mediiia_author',
    52: 'mediiia_education',
};

export const SortingTypeStringPeople: Record<SortingTypeIndexPeople, string> = {
    0: 'name',
    1: 'name',
    2: 'name',
    3: 'name',
    4: 'opa'
};

export const SortingTypeStringCompetitions: any = {
    1: 'current_competition',
    2: 'ended_competition'
}
import { SortingTypeIndexPeople } from "../pages/context/support/peopleSorting";


export enum SortingType {
    // latest = 'latest',
    popular = 'popular',
    moderation = 'moderation'
}

export enum SortingTypeIndex {
    price_inc = 10,
    price_dec = 9,
    // latest = 1,
    moderation = 1,
    popular = 2,
    current_competition = 1,
    ended_competition = 2,
    name = 3,
    projects = 4,
    opa = 5,
    updated_team = 6,
    score = 13,
    team_date = 18,
    relevant = 20,
    PersonPopular = 26,
    dezzignPersonPopular = 27,
    hsedesingPersonPopular = 28,
    geograffee_Art_PersonPopular = 29,
    personPopularLastPeriod = 30,
    dezzignPersonPopularLastPeriod = 31,
    editorsChoice = 32,
    course_start = 0,
    designer_name = 0,
    shop = 30,
    team_date_for_manual_tab = 33,
    mediiia_all = 50,
    mediiia_author = 51,
    mediiia_education = 52
}

export const SortingTypeString: Record<SortingTypeIndex, string> = {
    // 1: 'latest',
    0: 'course_start',
    1: 'moderation',
    2: 'popular',
    3: 'name',
    4: 'project',
    5: 'opa',
    6: 'updated_team',
    9: 'price_dec',
    10: 'price_inc',
    13: 'score',
    18: 'team_date',
    20: 'relevant',
    26: 'PersonPopular',
    27: 'dezzignPersonPopular',
    28: 'hsedesingPersonPopular',
    29: 'geograffee_Art_PersonPopular',
    30: 'shop',
    31: 'dezzignPersonPopularLastPeriod',
    32: 'editors_choice',
    33: 'team_date_for_manual_tab',
    50: 'mediiia_all',
    51: 'mediiia_author',
    52: 'mediiia_education',
};

export const SortingTypeStringPeople: Record<SortingTypeIndexPeople, string> = {
    0: 'name',
    1: 'name',
    2: 'name',
    3: 'name',
    4: 'opa'
};

export const SortingTypeStringCompetitions: any = {
    1: 'current_competition',
    2: 'ended_competition'
}
